import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useCallback, useRef } from 'react';
import { Field } from 'react-final-form';
import { propBool, propChildren, propFunc, propId, propStr, } from '../../../../../../../helpers/custom-prop-types';
import PlainInput from '../../../../../../Ui/Common/PlainInput';
const SeminarOneFormRadioField = (props) => {
    const { className, currentValue, disabled, inputClassName, isNumberValue, name, radioLabel, radioValue, validate, } = props;
    const renderPropsRef = useRef({});
    /**
     * 値が変更された時のイベント
     * @type {(function())|*}
     */
    const onChange = useCallback((e) => {
        const { value } = e.currentTarget;
        const { input } = renderPropsRef.current;
        // valueの値を数値として扱いたい場合はキャストしておく
        input.onChange(isNumberValue ? parseInt(value, 10) : value);
    }, [renderPropsRef, isNumberValue]);
    /**
     * コンポーネントの描画
     * @type {*}
     */
    const renderComponent = useCallback((renderProps) => {
        renderPropsRef.current = renderProps;
        const { value: inputValue } = renderProps.input;
        return (_jsx(PlainInput, { checked: inputValue === currentValue, className: inputClassName, disabled: disabled, input: renderProps.input, meta: renderProps.meta, onChange: onChange, type: 'radio' }));
    }, [currentValue, inputClassName, onChange, disabled, renderPropsRef]);
    return (_jsx("div", Object.assign({ className: clsx('professional_seminar_one_form_radio', className) }, { children: _jsx("div", Object.assign({ className: 'radio_wrapper field' }, { children: _jsx("label", Object.assign({ className: clsx('radio_label', !disabled && 'pointer') }, { children: _jsxs("div", Object.assign({ className: 'radio_inner' }, { children: [_jsx(Field, { component: renderComponent, name: name, type: 'radio', validate: validate, value: radioValue }), _jsx("i", {}), _jsx("span", Object.assign({ className: 'radio_text' }, { children: radioLabel }))] })) })) })) })));
};
SeminarOneFormRadioField.propTypes = {
    className: propStr(),
    currentValue: propId(),
    disabled: propBool(),
    inputClassName: propStr(),
    isNumberValue: propBool(),
    name: propStr().isRequired,
    radioLabel: propChildren().isRequired,
    radioValue: propId().isRequired,
    validate: propFunc(),
};
SeminarOneFormRadioField.defaultProps = {
    className: '',
    currentValue: undefined,
    disabled: false,
    inputClassName: '',
    isNumberValue: true,
    validate: undefined,
};
export default SeminarOneFormRadioField;
